import { render } from "./StoryAuthor.vue?vue&type=template&id=2cc736e0&lang=pug"
import script from "./StoryAuthor.vue?vue&type=script&lang=js"
export * from "./StoryAuthor.vue?vue&type=script&lang=js"

import "./StoryAuthor.vue?vue&type=style&index=0&id=2cc736e0&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__